import styles from "./styles.scss";

const Avatar = ({ src, alt, className = [], style, children, color }) => (
  src ? <img
    src={src}
    alt={alt}
    className={[styles.avatar, ...className].join(" ")}
    style={style}
  /> : <div className={[styles.avatar, ...className].join(" ")} style={{backgroundColor: color, ...style}}>{children}</div>
);

export default Avatar;



// WEBPACK FOOTER //
// ./components/avatar/index.js